import { render, staticRenderFns } from "./default.vue?vue&type=template&id=351a8605&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/vsts/work/1/a/NuxtApp/components/app/header/index.vue').default,AppLazyHydrate: require('/home/vsts/work/1/a/NuxtApp/components/app/LazyHydrate.vue').default,AppFooterTop: require('/home/vsts/work/1/a/NuxtApp/components/app/footer/Top.vue').default,AppFooter: require('/home/vsts/work/1/a/NuxtApp/components/app/footer/index.vue').default,AppLayout: require('/home/vsts/work/1/a/NuxtApp/components/app/Layout.vue').default})
